// UserRanksColumns.js
import { Badge } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { createColumnHelper } from "@tanstack/react-table";
import { formatDate } from "../../utils/formatDate";

export const getUserRanksColumns = (setSelectedRank, setModalOpen) => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("period", {
      header: "Periodo",
      cell: (info) => {
        const period = info.getValue();
        if (!period) return "—";
        const start = period.start.split('T')[0].split('-').reverse().join('/');
        const end = period.end.split('T')[0].split('-').reverse().join('/');
        return `${start} - ${end}`;
      },
    }),
    columnHelper.accessor("calculation_date", {
      header: "Fecha cálculo",
      cell: (info) =>
        info.getValue()
          ? formatDate(info.getValue())
          : "—",
    }),
    columnHelper.accessor("status", {
      header: "Estado",
      cell: (info) => {
        const status = info.getValue();
        const color =
          status === "COMPLETED"
            ? "success"
            : status === "PENDING"
            ? "warning"
            : "secondary";
        return <Badge color={color}>{status}</Badge>;
      },
    }),
    columnHelper.display({
      id: "totalPoints",
      header: "Total Puntos",
      cell: (props) => {
        const users = props.row.original.users || [];
        const totalPoints = users.reduce(
          (sum, user) => sum + (user.total_points || 0),
          0
        );
        return (
          <strong className="text-primary">
            {totalPoints.toLocaleString()} pts
          </strong>
        );
      },
    }),
    columnHelper.display({
      id: "usersCount",
      header: "Usuarios",
      cell: (props) => props.row.original.users?.length ?? 0,
    }),
    columnHelper.display({
      id: "actions",
      header: "Acciones",
      cell: (props) => (
        <Btn
          attrBtn={{
            color: "info",
            size: "sm",
            id: `view-rank-${props.row.original._id}`,
            onClick: () => {
              setSelectedRank(props.row.original);
              setModalOpen(true);
            },
          }}
        >
          <i className="fa fa-eye"></i> Ver detalle
        </Btn>
      ),
    }),
  ];
};
